import getAssetPath from '$utils/getAssetPath';

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
		icon: {
			type: String
		},
		customLabel: {
			type: String
		}
	},

	components: {

	},

	mounted() {

	},

	methods: {
		getAssetPath,
		toggle(e) {
			const val = this.context.value
			const next = Array.isArray(this.context.model) ? [...this.context.model] : []
			if (e.target.checked && !next.includes(val)) {
				next.push(val)
			} else if (!e.target.checked) {
				const idx = next.indexOf(val)
				if (idx > -1) next.splice(idx, 1)
			}
			this.context.model = next
		},
	},
};
